import useStateValue from "frontend/state/value";
import { useEffect } from "react";
import LoadedState from "frontend/state/loadedState";
import { loadBoards } from "frontend/services/boardsService";

export default function useBoards() {
  const [{ user, boards, boardsState }, dispatch] = useStateValue();
  const isLoading = [LoadedState.initial, LoadedState.loading].includes(boardsState);

  useEffect(() => {
    if (user && dispatch) {
      loadBoards(dispatch);
    }
  }, [user?.id]);

  return { boards, isLoading };
}
